/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React from 'react'
import { Link } from 'react-router-dom'
import Pagination from '../../Components/Pagination'
import EmptyOrderPage from '../MyOrders/EmptyOrderPage'


const BulkOfferListing = ({tab, setTab, bulkOfferList, setbulkOfferList, totalPage, currentPage, alldata, loading, emptyData, setCurrentPage, setLoading, searchValue}) => {

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };
    return (
        <div className={`tab-pane fade ${tab === 'bulk_offer' ? 'show active' : ''}`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
            {bulkOfferList.length > 0 && bulkOfferList.map((offer, index) => (
                <motion.div   
                    animate={{ opacity: 1, x: 0 }}
                    initial={{ opacity: 0, x: -10 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 0.15 }} 
                    key={index}
                    className="w-full rounded-[10px] shadow-s16 sm:pl-[18px] pl-3 sm:pr-3.5 pr-2.5 sm:pt-[22px] pt-4 sm:pb-[32px] pb-5 mb-2.5"
                >
                    <div className="relative ">
                        <ul className="flex justify-end">
                            <li>
                                <p className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit absolute right-3 top-[12px]">{offer.industrial_pocket}</p>
                            </li>
                        </ul>
                        <div className="">
                            <div className="flex items-center justify-between md:flex-nowrap flex-wrap">
                                <div className="flex items-center sm:flex-nowrap flex-wrap md:w-[60%] w-full">
                                    <motion.img
                                        className="box"
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{
                                            duration: 0.8,
                                            delay: 0.5,
                                            ease: [0, 0.71, 0.2, 1.01]
                                        }}
                                        src="images/related-offer.svg" alt="icon"/>
                                    <div className="sm:pl-5 w-full">
                                        <ul className="sm:mt-0 mt-2">
                                            <li className="font-semibold sm:text-sm56 text-lg text-[#090406]">{offer?.offer_code}</li>
                                            <li className="text-[#44445E] font-normal text-xs13 my-[7px]">Validity: {offer.start_date} to {offer.end_date}<span className="px-2">|</span><span className="font-semibold">{offer.offer_value}</span></li>
                                            <li className="text-[#44445E] font-normal text-sm49">{offer.description}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="flex items-center justify-end lg:mt-10 mt-5 sm:ml-7 ml-0 self-end md:w-[40%] w-full">
                                    <Link to={`/bulk-offers/${offer.offer_code.split('/').join('-')}?code=${encodeURIComponent(offer.offer_code)}`}>
                                        <motion.button
                                            initial={{ opacity: 0, scale: 0.9 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{
                                                duration: 0.8,
                                                delay: 0.5,
                                                ease: [0, 0.71, 0.2, 1.01]
                                            }} type="button" 
                                            className="sm:w-[284px] w-[170px] h-10 rounded-lg bg-[#555259] font-semibold text-sm text-[#FFFFFF]">
                                            View Offer
                                        </motion.button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>

            ))}
            {!loading && bulkOfferList && bulkOfferList.length > 0 && (
                <Pagination
                    handlePageClick={handlePageClick}
                    totalPage={totalPage}
                    List={alldata}
                    currentPage={currentPage}
                />
            )}
            {emptyData && <EmptyOrderPage search="yes" text="no Bulk Offers" all={searchValue.length > 0 ? 'under searched term' : 'found'} />}
        </div>


    )
}

export default BulkOfferListing